import { Dialog } from "@mui/material";
import React, { useState } from "react";

import { ReactComponent as QuestionMarkIcon } from "assets/img/svg/QuestionMarkConfirmationDialog.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";

import {
  getRequesterDetails,
  rejectionDialogList,
  subHeadingStyle,
} from "./constant";

const ConfirmRejectionDialog = ({
  isOpen,
  setOpen,
  rejectionDetail = {},
  statusHandler,
  status = "REJECT",
  title = "Reject EPMR cancellation request",
  subheading = "EPMR cancellation request will be rejected. Please check the details.",
}) => {
  const [remark, setRemark] = useState("");

  const closeDialog = () => {
    setOpen(false);
    setRemark(""); //reset the Reamrks field
  };

  return (
    <Dialog open={isOpen} fullWidth size="md">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          <QuestionMarkIcon />
          <CrossIcon onClick={closeDialog} />
        </div>

        <div className="header">{title}</div>
        <div style={subHeadingStyle}>{subheading}</div>
        <div className="d-flex justify-content-between mt-4">
          {getRequesterDetails(rejectionDialogList, rejectionDetail)}
        </div>

        <div className="mt-4">
          <div className="mb-2">Remarks*</div>
          <AInput
            value={remark}
            handler={(value) => setRemark(value)}
            placeholder="Add remarks"
            style={{ height: "46px" }}
            maxLength={150} // char limit: 150
          />
        </div>

        <div className="mt-4">
          <button className="no-ml-btn" onClick={closeDialog}>
            Go back
          </button>

          <AButton
            className="reject-btn px-5"
            variant="danger_filled"
            disabled={!remark.length}
            onClick={() => {
              statusHandler(rejectionDetail, remark, status);
            }}
            style={{ width: "max-content" }}
          >
            {status === "PENDING" ? "Request Cancellation" : "Reject"}
          </AButton>
        </div>
      </div>
    </Dialog>
  );
};
export default ConfirmRejectionDialog;
